// The One Retail shell's in-page bridge - ADR-007 - https://github.com/owg-digital/rtls-one-retail/tree/main/frontend/shell/docs/adrs/007-navigation-model-and-contribution.md
// Promo runs in the shell's own document when embedded, so the bridge is a plain object on `window`
// rather than a message channel. It is absent standalone, so every call site guards:
// `shellBridge()?.navbar.register(...)`.

// Promo's registry key in the shell. Navbar items and namespaced roles key off it.
export const APP_KEY = 'promo';

// The bridge capability level this build is written against - ADR-019 - https://github.com/owg-digital/rtls-one-retail/tree/main/frontend/shell/docs/adrs/019-bridge-versioning.md
// The shell bumps the level on every addition and never removes or re-types a member, and a shell
// reporting no version is level 1, so a promo ahead of the shell loses only the features the shell lacks.
export const PLATFORM_BRIDGE_VERSION = 1;

// The shell bridge if it offers capability `level`, else null (always null standalone). Pass the
// level that added the feature you call; every feature promo uses today is level 1.
export function shellBridge(level = 1) {
    const bridge = window.RETAIL_PLATFORM;
    return bridge && (bridge.version ?? 1) >= level ? bridge : null;
}
